var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPermphone = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_529_2834",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.700012,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_529_2834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7 13V4C12.7 3.71667 12.7958 3.47917 12.9875 3.2875C13.1792 3.09583 13.4167 3 13.7 3H20.7C20.9833 3 21.2208 3.09583 21.4125 3.2875C21.6042 3.47917 21.7 3.71667 21.7 4V9C21.7 9.28333 21.6042 9.52083 21.4125 9.7125C21.2208 9.90417 20.9833 10 20.7 10H15.7L12.7 13ZM14.7 8H19.7V5H14.7V8ZM20.65 21C18.5667 21 16.5083 20.5458 14.475 19.6375C12.4417 18.7292 10.5917 17.4417 8.92501 15.775C7.25835 14.1083 5.97085 12.2583 5.06251 10.225C4.15418 8.19167 3.70001 6.13333 3.70001 4.05C3.70001 3.75 3.80001 3.5 4.00001 3.3C4.20001 3.1 4.45001 3 4.75001 3H8.80001C9.03335 3 9.24168 3.07917 9.42501 3.2375C9.60835 3.39583 9.71668 3.58333 9.75001 3.8L10.4 7.3C10.4333 7.56667 10.425 7.79167 10.375 7.975C10.325 8.15833 10.2333 8.31667 10.1 8.45L7.67501 10.9C8.00835 11.5167 8.40418 12.1125 8.86251 12.6875C9.32085 13.2625 9.82501 13.8167 10.375 14.35C10.8917 14.8667 11.4333 15.3458 12 15.7875C12.5667 16.2292 13.1667 16.6333 13.8 17L16.15 14.65C16.3 14.5 16.4958 14.3875 16.7375 14.3125C16.9792 14.2375 17.2167 14.2167 17.45 14.25L20.9 14.95C21.1333 15.0167 21.325 15.1375 21.475 15.3125C21.625 15.4875 21.7 15.6833 21.7 15.9V19.95C21.7 20.25 21.6 20.5 21.4 20.7C21.2 20.9 20.95 21 20.65 21ZM6.72501 9L8.37501 7.35L7.95001 5H5.72501C5.80835 5.68333 5.92501 6.35833 6.07501 7.025C6.22501 7.69167 6.44168 8.35 6.72501 9ZM15.675 17.95C16.325 18.2333 16.9875 18.4583 17.6625 18.625C18.3375 18.7917 19.0167 18.9 19.7 18.95V16.75L17.35 16.275L15.675 17.95Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPermphone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/permphone.cb1b1b6a.svg";
export { ForwardRef as ReactComponent };